import { useState, useEffect } from 'react';

const useFetchIp = (apiUrl) => {
  const [ip, setIp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIp = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_ip.php`);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        setIp(data.H);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchIp();
  }, [apiUrl]);

  return { ip, loading, error };
};

export default useFetchIp;
